<div class="side-menu-container">
  <ng-scrollbar>
    @if (sideMenuTitle) {
    <div class="sidebar-header">
      <h1 class="sidebar-title">{{ sideMenuTitle | translate }}</h1>
    </div>
    }
    <div class="sidebar-tab">
      <mat-nav-list>
        @for (list of tabList; track list.name; let i = $index) { @if
        (list?.hideIf === true ? false : true) {
        <div
          class="tab-list"
          [class.active]="isTabActive(list)"
          [attr.data-cy]="list.name"
        >
          <a mat-list-item (click)="onMenuClick(i, list)">
            <span class="nav-list-contents">
              @if (list?.icon) {
              <mat-icon>{{ list?.icon }}</mat-icon>
              }
              <span
                mat-line
                class="tab-name"
                matTooltip="{{ list.tooltip ? list.tooltip : '' }}"
                >{{ list?.name | translate }}</span
              >
              @if (list?.number) {
              <span>&nbsp;({{ list?.number() }})</span>
              }
            </span>
          </a>
        </div>
        } }
      </mat-nav-list>
    </div>
  </ng-scrollbar>
</div>
